function createAction(name) {
  return `@@propertyAnnotations/${name}`;
}
export const TOGGLE_PROPERTY_ANNOTATIONS = createAction('TOGGLE_PROPERTY_ANNOTATIONS');
const togglePropertyAnnotationsAction = newStatus => ({
  type: TOGGLE_PROPERTY_ANNOTATIONS,
  payload: {
    newStatus
  }
});
export const togglePropertyAnnotations = newStatus => dispatch => {
  dispatch(togglePropertyAnnotationsAction(newStatus));
};